import { Applicant } from '@core/services/dto/applicant.dto';
import { ApplicationMenuViewItemDto } from '@core/services/dto/Application-view-menu.dto';
import { ApplicationProduct } from '@core/services/dto/applicationproduct.dto';
import { formateUTCtoTZ } from '@shared/utils';

export class ApplicationMenuViewItemModel {
  publicId: string;
  applicationId: number;
  id: number;
  siteId: string;
  dateAdded: Date;
  dateReceived: Date;
  dateCompleted?: Date;
  completedBy?: string;
  dateUpdated?: Date;
  updatedBy?: string;
  status: string;
  archived: boolean;
  archivedBy?: string;
  dateArchived?: Date;
  type?: string;
  chequeAmount?: number;
  inBranch?: boolean;
  branchId?: number;
  branchName?: string;
  staffBranchId?: number;
  lastApplicationStep?: string;
  lastApplicationSubStep?: string;
  assignedToID?: string;
  assignedToName?: string;
  dateAssigned?: Date;
  combinedIncome?: number;
  combinedNetworth?: number;
  combinedQualifyingTDS?: number;
  combinedQualifyingGDS?: number;
  combinedApprovedTDS?: number;
  combinedApprovedGDS?: number;
  lcsQualifyingRateResponse?: any;
  lcsApprovalRateResponse?: any;
  lcsBankOfCanadaRateResponse?: any;
  originatingChannel?: string;
  completingChannel?: string;
  preferredlanguage?: string;
  lastViewedDate?: Date;
  initiateByName?: string;
  lastViewedBy?: string;
  preferredBranch?: number;
  promoPageId?: number;
  preferredBranchName?: string;
  applicants: Applicant[];
  applicationProducts: ApplicationProduct[];
  constructor(dto: ApplicationMenuViewItemDto) {
    this.publicId = dto?.publicId;
    this.applicationId = dto?.applicationId;
    this.id = dto?.id;
    this.siteId = dto?.siteId;
    this.dateUpdated = formateUTCtoTZ(dto?.dateUpdated) ? new Date(formateUTCtoTZ(dto?.dateUpdated)) : null;
    this.dateAdded = dto?.dateAdded ? new Date(dto.dateAdded) : null;
    this.dateReceived = dto?.dateReceived ? new Date(dto.dateReceived) : null;
    this.dateCompleted = dto?.dateCompleted ? new Date(dto.dateCompleted) : null;
    this.dateArchived = dto?.dateArchived ? new Date(dto.dateArchived) : null;
    this.dateAssigned = dto?.dateAssigned ? new Date(dto.dateAssigned) : null;
    this.lastViewedDate = dto?.lastViewedDate ? new Date(dto.lastViewedDate) : null;
    this.completedBy = dto?.completedBy;
    this.updatedBy = dto?.updatedBy;
    this.status = dto?.status;
    this.archived = dto?.archived;
    this.archivedBy = dto?.archivedBy;
    this.type = dto?.type;
    this.chequeAmount = dto?.chequeAmount;
    this.inBranch = dto?.inBranch;
    this.branchId = dto?.branchId;
    this.branchName = dto?.branchName;
    this.staffBranchId = dto?.staffBranchId;
    this.lastApplicationStep = dto?.lastApplicationStep;
    this.lastApplicationSubStep = dto?.lastApplicationSubStep;
    this.assignedToID = dto?.assignedToID;
    this.assignedToName = dto?.assignedToName;
    this.combinedIncome = dto?.combinedIncome;
    this.combinedNetworth = dto?.combinedNetworth;
    this.combinedQualifyingTDS = dto?.combinedQualifyingTDS;
    this.combinedQualifyingGDS = dto?.combinedQualifyingGDS;
    this.combinedApprovedTDS = dto?.combinedApprovedTDS;
    this.combinedApprovedGDS = dto?.combinedApprovedGDS;
    this.lcsQualifyingRateResponse = dto?.lcsQualifyingRateResponse;
    this.lcsApprovalRateResponse = dto?.lcsApprovalRateResponse;
    this.lcsBankOfCanadaRateResponse = dto?.lcsBankOfCanadaRateResponse;
    this.originatingChannel = dto?.originatingChannel === 'InBranch' ? 'In-Branch' : dto?.originatingChannel;
    this.completingChannel = dto?.completingChannel === 'InBranch' ? 'In-Branch' : dto?.completingChannel;
    this.preferredlanguage = dto?.preferredlanguage;
    this.lastViewedBy = dto?.lastViewedBy;
    this.preferredBranch = dto?.preferredBranch;
    this.preferredBranchName = dto?.preferredBranchName;
    this.applicants=dto?.applicants;
    this.applicationProducts=dto?.applicationProducts;
    this.initiateByName =dto?.initiateByName;
    this.promoPageId = dto?.promoPageId;
  }
}
